<mat-card class="sub-section">
  <mat-card-header>
    <mat-card-title>
      <ng-content select="[title]"></ng-content>
    </mat-card-title>
    <mat-card-subtitle>
      <ng-content select="[subtitle]"></ng-content>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="table-scroll-container full-height-table">
      <table
        class="win-rates-table"
        mat-table
        [dataSource]="dataSource"
        (matSortChange)="sortChange($event)"
        matSort
        matSortStart="desc"
        [matSortActive]="orderBy"
        [matSortDirection]="orderDirection"
      >
        @for (column of tableColumns; track column) {
          <ng-container [matColumnDef]="column.name">
            <th mat-header-cell mat-sort-header class="no-border" [ngClass]="column.classes" *matHeaderCellDef>
              {{ column.i18nName | translate }}
            </th>

            <td mat-cell *matCellDef="let element" [ngClass]="column.classes">
              <span>
                {{ column.prefix }}
                {{ column.title ? '' : get(element, column.key) }}
                {{ column.title ? (column.title(get(element, column.key)) | translate) : '' }}
                {{ column.postfix }}
              </span>
            </td>

            <td mat-footer-cell *matFooterCellDef="let element" [ngClass]="column.classes">
              {{ element | json }}
              @if (column.isTotalColumn) {
                <span>
                  {{ 'performance.numFromTo.total' | translate }}
                </span>
              }
              @if (!column.isTotalColumn) {
                <span>
                  {{ column.prefix }}
                  {{ column.title ? '' : getTotalValue(column.key) }}
                  {{
                    column.title
                      ? (column.title(getTotalValue(column.key), performanceSummaryFlag.SUMMARY_COLUMN) | translate)
                      : ''
                  }}
                  {{ column.postfix }}
                </span>
              }
            </td>
          </ng-container>
        }
        @for (column of tableColumnsFooterResults; track column) {
          <ng-container [matColumnDef]="column.name">
            <td mat-footer-cell *matFooterCellDef [ngClass]="column.classes">
              <span>
                {{ column.prefix }}
                {{ column.title ? '' : getResultsValue(column.key) }}
                {{ column.title ? (column.title(getResultsValue(column.key)) | translate) : '' }}
                {{ column.postfix }}
              </span>
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumnsFooterResults"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
